/**
 * To be used in an array.filter() to filter out undefined values with type narrowing
 */
export const isNotUndefined = <T>(value: T | undefined): value is T => value !== undefined;

export const isNotNullish = <T>(value?: T | null | undefined): value is T =>
  value !== null && value !== undefined;
